<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
import { ref, onMounted,defineProps,watchEffect } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Array,
    default: () => [],
  },
})
// console.log(props.leftData2);
const myEcharts = ref(null);

onMounted(() => {

  initChart(props.listData);
});


function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);



  const option= {
    grid: {
      top: '15%',
      left: '8%',
      right: '8%',
      bottom: '8%',
      containLabel: true,
    },
    xAxis: [{
      type: 'category',
      boundaryGap: false,
      axisLine: {
        show: false,
      },
      axisLabel: {
        interval:0,
        // rotate:45,
        alignWithLabel: true,
        textStyle: {
          color: '#959FA9',
          fontSize: 24
        },
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed',
          color: 'rgba(226, 226, 226, 0.2)',
          width: 1
        }
      },
      data: [ '2023/10', '2023/11', '2023/12', '2024/01', '2024/02', '2024/03'],
    }],
    yAxis: [{
      type: 'value',
      name:'元/斤',
      nameTextStyle:{
        fontSize:26,
        padding:[0,0,10,0]
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        show: false,
        lineStyle: {
          type: 'dashed',
          color: 'rgba(226, 226, 226, 0.3)',
          width: 1
        }
      },
      axisLine: {
        show: false,
        lineStyle: {
          color: 'rgb(2,185,208)',
        },
      },
      axisLabel: {
        show: false,
      },
    }],
    series: [{
      name: '',
      type: 'line',
      smooth: true,
      symbol: 'emptyCircle',
      showAllSymbol: true,
      symbolSize: 20,
      label: {
        show: true,
        position: 'top',
        fontSize: 26,
        color:"#fff",
        // formatter: function (params) {
        //   return params.value + '元/斤'
        // }

      },
      lineStyle: {
        width: 10,
      },
      itemStyle: {
        normal: {
          color: {
              x: 1,
              y: 0,
              x2: 0,
              y2: 0,
              colorStops: [{
                offset: 0,
                color: 'rgba(10, 236,207, 0.02)'
              },
                {
                  offset: 0.3,
                  color: 'rgba(10, 236,207, 0.8)'
                },
                {
                  offset: 0.8,
                  color: 'rgba(22, 159, 113, 0.8)'
                },
                {
                  offset: 1,
                  color: 'rgba(22, 159, 113, 0.02)'
                }],
            }
        }
      },

      data: [ 2.2,2.22,2.23,2.18,1.85,1.86]
    }

    ]
  };// 将你的ECharts配置项放在这里
  chartInstance.setOption(option);

}
window.addEventListener("resize", () => {
  chartInstance.resize();
});
function splitArray(array, size) {
  var result = Array.from({ length: Math.ceil(array.length / size) }, function(_, index) {
    return array.slice(index * size, index * size + size);
  });
  return result;
}
</script>
<style lang="less"></style>
